import { ProductType } from "@models/product/enums/productType";

export const DEFAULT_MANAGER_CODE_ERROR_MESSAGE = "Invalid manager code";
export const MAX_MANAGER_CODE_NUM_OF_CHARS = 3;
export const MANAGER_CODE_REGEX = /^[A-Za-z]*$/m;
export const CURRENT_SUPPORTED_INVESTMENT_PRODUCT_TYPES = [
  ProductType.ManagedInvestment,
];
